import { PropsWithChildren } from 'react';
import { attempt } from 'yoso';
import { useLoginSecurity } from '~/components/Auth/Login/Security/LoginSecurity.hooks';

export const LoginSecurity = ({ children }: PropsWithChildren<unknown>) => (
  <>{attempt(children, useLoginSecurity({ useErrorBoundary: true }))}</>
);
